import { Component, ViewEncapsulation, Input, OnInit, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges  } from '@angular/core';
import { NgModel, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from '../default-class/value-accessor';
import { CheckboxModel } from './checkbox.model';

@Component({
  selector: 'tidy-checkbox',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./checkbox.component.scss'],
  templateUrl: 'checkbox.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CheckboxComponent,
    multi: true,
  }],
})

export  class CheckboxComponent extends ValueAccessorBase<any> implements OnInit, OnChanges {
  @Input() items: CheckboxModel;
  @Input() label: string;
  @Input() icon: string;
  @ViewChild(NgModel, {static: false}) model: NgModel;
  @Input() checked = false;
  @Input() initValue: string | number | boolean;
  @Input() disabled = false;
  public selected: string;
  public loaded = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  ngOnInit() {
    this.value = this.initValue;
    this.selected = this.value;
    this.checked = this.initValue === true || this.initValue === 'true' || this.initValue === 1;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.initValue) {
      this.value = changes.initValue?.currentValue;
      this.selected = this.value;
      this.checked = this.value === true || this.value === 'true' || this.value === 1;
    }
    if (changes['checked']) {
      this.checked = changes.checked?.currentValue;
    }
  }

  selectItem(event?: any) {
    // Get the actual checked state from the mat-checkbox change event
    let newCheckedState: boolean;
    if (event && event.checked !== undefined) {
      // Use the checked state from the mat-checkbox change event
      newCheckedState = event.checked;
    } else if (event && event.target) {
      // Fallback to target's checked state
      newCheckedState = event.target.checked;
    } else {
      // Fallback: toggle the current checked state
      this.checked = !this.checked;
      newCheckedState = this.checked;
    }
    // Sync internal state with the actual checkbox state
    this.value = newCheckedState;
    this.checked = newCheckedState;
    this.checkedChange.emit(newCheckedState);
  }
}
